import createIcon from "./create-icon";

export default createIcon(
  "PlusSolid",
  [
    [
      "path",
      {
        d: "M12 3.75c0-.69-.56-1.25-1.25-1.25s-1.25.56-1.25 1.25V10.5H3.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25H9.5v6.75c0 .69.56 1.25 1.25 1.25s1.25-.56 1.25-1.25V13h6.75c.69 0 1.25-.56 1.25-1.25s-.56-1.25-1.25-1.25H12V3.75z",
      },
    ],
  ],
  "currentColor"
);
